import FocusGroupExample from "./examples/FocusGroup.Example";

export default [
    {
        title: "FocusGroup example",
        component: FocusGroupExample,
        code: require("!raw-loader!./examples/FocusGroup.Example.tsx")
    }
];
